<template>
	<b-row class="text-right">
		<b-col>
			<b-button-group class="my-3">
				<b-button
					:class="isTable ? 'td-btn-teal' : 'td-btn-outline-teal'"
					@click="updateIsTable(true), updateIsChart(false), updateIsMap(false)"
					:disabled="!isFinishProcessChoosenData"
				>
					<b-icon icon="table" /> Tabel
				</b-button>
				<b-button
					:class="isChart ? 'td-btn-teal' : 'td-btn-outline-teal'"
					@click="updateIsTable(false), updateIsChart(true), updateIsMap(false)"
					:disabled="!isFinishProcessChoosenData"
				>
					<b-icon icon="bar-chart-line" flip-h rotate="270" /> Grafik
				</b-button>
				<b-button
					:class="isMap ? 'td-btn-teal' : 'td-btn-outline-teal'"
					@click="updateIsTable(false), updateIsChart(false), updateIsMap(true)"
					disabled
					title="coming soon"
				>
					<b-icon icon="map" /> Peta
				</b-button>
			</b-button-group>
		</b-col>
	</b-row>
</template>

<!-- javascript section-->
<script type="module">
//import js modules section

//local registration for output component
export default {
	name: "VisualizationTableChartMenu",
	data() {
		return {};
	},
	props: [
		"isFinishProcessChoosenData",
		"isTable",
		"isChart",
		"isMap",
		"updateIsTable",
		"updateIsChart",
		"updateIsMap",
	],
	created() {},
	destroyed() {},
	mounted() {},
	computed: {},
	watch: {},
	methods: {},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 15-03-2022 -->